export enum TwitterEvents {
  checkoutInitiated = 'tw-o347p-omest',
  addtoCart = 'tw-o347p-omess',
  purchasePaidPlan = 'tw-o347p-omesp'
}
